export const colors = [
    {
      "primary": "Aqua",
      "secondary": "#cdffff"
    },
    {
      "primary": "Aquamarine",
      "secondary": "#d9ffff"
    },
    {
      "primary": "Blue",
      "secondary": "#ebebff"
    },
    {
      "primary": "BlueViolet",
      "secondary": "#ffe9ff"
    },
    {
      "primary": "Chartreuse",
      "secondary": "#ecf5e4"
    },
    {
      "primary": "Coral",
      "secondary": "#fff7c8"
    },
    {
      "primary": "CornflowerBlue",
      "secondary": "#d2ffff"
    },
    {
      "primary": "Crimson",
      "secondary": "#ffe6ff"
    },
    {
      "primary": "Cyan",
      "secondary": "#cdffff"
    },
    {
      "primary": "DarkOrange",
      "secondary": "#fcf1e3"
    },
    {
      "primary": "DarkOrchid",
      "secondary": "#ffe6ff"
    },
    {
      "primary": "DarkRed",
      "secondary": "#ffebeb"
    },
    {
      "primary": "DarkSalmon",
      "secondary": "#fff0d4"
    },
    {
      "primary": "DarkSeaGreen",
      "secondary": "#e9ffe9"
    },
    {
      "primary": "DarkTurquoise",
      "secondary": "#cdffff"
    },
    {
      "primary": "DarkViolet",
      "secondary": "#ffe6ff"
    },
    {
      "primary": "DeepPink",
      "secondary": "#ffe6ff"
    },
    {
      "primary": "DeepSkyBlue",
      "secondary": "#cdffff"
    },
    {
      "primary": "DodgerBlue",
      "secondary": "#cdffff"
    },
    {
      "primary": "FireBrick",
      "secondary": "#ffeaea"
    },
    {
      "primary": "Fuchsia",
      "secondary": "#ffe6ff"
    },
    {
      "primary": "Gold",
      "secondary": "#faf6de"
    },
    {
      "primary": "GoldenRod",
      "secondary": "#faf0d8"
    },
    {
      "primary": "Green",
      "secondary": "#dcffdc"
    },
    {
      "primary": "GreenYellow",
      "secondary": "#ecfcd5"
    },
    {
      "primary": "HotPink",
      "secondary": "#ffebff"
    },
    {
      "primary": "IndianRed",
      "secondary": "#fce3e3"
    },
    {
      "primary": "Khaki",
      "secondary": "#ffffe6"
    },
    {
      "primary": "LawnGreen",
      "secondary": "#ebf8de"
    },
    {
      "primary": "LightBlue",
      "secondary": "#ffffff"
    },
    {
      "primary": "LightCoral",
      "secondary": "#ffeeee"
    },
    {
      "primary": "LightGreen",
      "secondary": "#eaffea"
    },
    {
      "primary": "LightPink",
      "secondary": "#ffffff"
    },
    {
      "primary": "LightSalmon",
      "secondary": "#fffad4"
    },
    {
      "primary": "LightSeaGreen",
      "secondary": "#caffff"
    },
    {
      "primary": "LightSkyBlue",
      "secondary": "#e1ffff"
    },
    {
      "primary": "Lime",
      "secondary": "#dcffdc"
    },
    {
      "primary": "Magenta",
      "secondary": "#ffe6ff"
    },
    {
      "primary": "MediumAquaMarine",
      "secondary": "#caffff"
    },
    {
      "primary": "MediumOrchid",
      "secondary": "#ffe6ff"
    },
    {
      "primary": "MediumPurple",
      "secondary": "#ffe8ff"
    },
    {
      "primary": "MediumSeaGreen",
      "secondary": "#cdffff"
    },
    {
      "primary": "MediumSlateBlue",
      "secondary": "#fdeaff"
    },
    {
      "primary": "MediumSpringGreen",
      "secondary": "#cdffff"
    },
    {
      "primary": "MediumTurquoise",
      "secondary": "#caffff"
    },
    {
      "primary": "MediumVioletRed",
      "secondary": "#ffe7ff"
    },
    {
      "primary": "Olive",
      "secondary": "#fafadd"
    },
    {
      "primary": "OliveDrab",
      "secondary": "#f4fce4"
    },
    {
      "primary": "Orange",
      "secondary": "#faf2e3"
    },
    {
      "primary": "OrangeRed",
      "secondary": "#fae7e0"
    },
    {
      "primary": "Orchid",
      "secondary": "#ffe8ff"
    },
    {
      "primary": "PaleGoldenRod",
      "secondary": "#ffffff"
    },
    {
      "primary": "PaleGreen",
      "secondary": "#f2fff2"
    },
    {
      "primary": "PaleTurquoise",
      "secondary": "#ffffff"
    },
    {
      "primary": "PaleVioletRed",
      "secondary": "#ffe8ff"
    },
    {
      "primary": "Pink",
      "secondary": "#ffffff"
    },
    {
      "primary": "Plum",
      "secondary": "#fffaff"
    },
    {
      "primary": "PowderBlue",
      "secondary": "#ffffff"
    },
    {
      "primary": "Red",
      "secondary": "#ffebeb"
    },
    {
      "primary": "RosyBrown",
      "secondary": "#fff3f3"
    },
    {
      "primary": "RoyalBlue",
      "secondary": "#d7ffff"
    },
    {
      "primary": "Salmon",
      "secondary": "#ffeee0"
    },
    {
      "primary": "SandyBrown",
      "secondary": "#fffeba"
    },
    {
      "primary": "SeaGreen",
      "secondary": "#cefff7"
    },
    {
      "primary": "Sienna",
      "secondary": "#fff2cd"
    },
    {
      "primary": "SkyBlue",
      "secondary": "#e1ffff"
    },
    {
      "primary": "SlateBlue",
      "secondary": "#fbebff"
    },
    {
      "primary": "SpringGreen",
      "secondary": "#cdffff"
    },
    {
      "primary": "Tomato",
      "secondary": "#ffefd3"
    },
    {
      "primary": "Turquoise",
      "secondary": "#ccffff"
    },
    {
      "primary": "Violet",
      "secondary": "#ffe6ff"
    },
    {
      "primary": "Yellow",
      "secondary": "#fcfce0"
    },
    {
      "primary": "YellowGreen",
      "secondary": "#f0f8df"
    }
  ];
export const colors2 = [{"primary":"Aqua","secondary":"#a0ffff"},{"primary":"Aquamarine","secondary":"#d9ffff"},{"primary":"Blue","secondary":"#e6e6ff"},{"primary":"BlueViolet","secondary":"#ffd5ff"},{"primary":"Chartreuse","secondary":"#d9ff5a"},{"primary":"Coral","secondary":"#ffe3b4"},{"primary":"CornflowerBlue","secondary":"#c8f9ff"},{"primary":"Crimson","secondary":"#ffd7ff"},{"primary":"Cyan","secondary":"#a0ffff"},{"primary":"DarkOrange","secondary":"#fff064"},{"primary":"DarkOrchid","secondary":"#ffd7ff"},{"primary":"DarkRed","secondary":"#ffdcdc"},{"primary":"DarkSalmon","secondary":"#fff0d4"},{"primary":"DarkSeaGreen","secondary":"#e9ffe9"},{"primary":"DarkTurquoise","secondary":"#a0ffff"},{"primary":"DarkViolet","secondary":"#ffd7ff"},{"primary":"DeepPink","secondary":"#ffd7ff"},{"primary":"DeepSkyBlue","secondary":"#a0ffff"},{"primary":"DodgerBlue","secondary":"#a0ffff"},{"primary":"FireBrick","secondary":"#ffdbdb"},{"primary":"Fuchsia","secondary":"#ffd7ff"},{"primary":"Gold","secondary":"#ffff5a"},{"primary":"GoldenRod","secondary":"#ffff7a"},{"primary":"Green","secondary":"#beffbe"},{"primary":"GreenYellow","secondary":"#ffff89"},{"primary":"HotPink","secondary":"#ffd7ff"},{"primary":"IndianRed","secondary":"#fccfcf"},{"primary":"Khaki","secondary":"#ffffe6"},{"primary":"LawnGreen","secondary":"#e0ff64"},{"primary":"LightBlue","secondary":"#ffffff"},{"primary":"LightCoral","secondary":"#ffe4e4"},{"primary":"LightGreen","secondary":"#eaffea"},{"primary":"LightPink","secondary":"#ffffff"},{"primary":"LightSalmon","secondary":"#fffad4"},{"primary":"LightSeaGreen","secondary":"#a2ffff"},{"primary":"LightSkyBlue","secondary":"#e1ffff"},{"primary":"Lime","secondary":"#beffbe"},{"primary":"Magenta","secondary":"#ffd7ff"},{"primary":"MediumAquaMarine","secondary":"#c0ffff"},{"primary":"MediumOrchid","secondary":"#ffd7ff"},{"primary":"MediumPurple","secondary":"#ffdeff"},{"primary":"MediumSeaGreen","secondary":"#b4ffe9"},{"primary":"MediumSlateBlue","secondary":"#f3e0ff"},{"primary":"MediumSpringGreen","secondary":"#a0ffff"},{"primary":"MediumTurquoise","secondary":"#a2ffff"},{"primary":"MediumVioletRed","secondary":"#ffd3ff"},{"primary":"Olive","secondary":"#f8f878"},{"primary":"OliveDrab","secondary":"#d9fc91"},{"primary":"Orange","secondary":"#ffff5a"},{"primary":"OrangeRed","secondary":"#ffe5a0"},{"primary":"Orchid","secondary":"#ffd4ff"},{"primary":"PaleGoldenRod","secondary":"#ffffff"},{"primary":"PaleGreen","secondary":"#f2fff2"},{"primary":"PaleTurquoise","secondary":"#ffffff"},{"primary":"PaleVioletRed","secondary":"#ffdeff"},{"primary":"Pink","secondary":"#ffffff"},{"primary":"Plum","secondary":"#fffaff"},{"primary":"PowderBlue","secondary":"#ffffff"},{"primary":"Red","secondary":"#ffdcdc"},{"primary":"RosyBrown","secondary":"#ffe9e9"},{"primary":"RoyalBlue","secondary":"#c8f0ff"},{"primary":"Salmon","secondary":"#ffe4d6"},{"primary":"SandyBrown","secondary":"#fffeba"},{"primary":"SeaGreen","secondary":"#b5ffde"},{"primary":"Sienna","secondary":"#ffe3be"},{"primary":"SkyBlue","secondary":"#e1ffff"},{"primary":"SlateBlue","secondary":"#f1e1ff"},{"primary":"SpringGreen","secondary":"#a0ffff"},{"primary":"Tomato","secondary":"#ffe5c9"},{"primary":"Turquoise","secondary":"#a4ffff"},{"primary":"Violet","secondary":"#ffdcff"},{"primary":"Yellow","secondary":"#fcfcc9"},{"primary":"YellowGreen","secondary":"#f4ff8c"}];
export const color = ["Aqua", "Aquamarine", "Blue", "BlueViolet", "Chartreuse", "Coral", "CornflowerBlue", "Crimson", "Cyan", "DarkOrange", "DarkOrchid", "DarkRed", "DarkSalmon", "DarkSeaGreen", "DarkTurquoise", "DarkViolet", "DeepPink", "DeepSkyBlue", "DodgerBlue", "FireBrick", "Fuchsia", "Gold", "GoldenRod", "Green", "GreenYellow", "HotPink", "IndianRed", "Khaki", "LawnGreen", "LightBlue", "LightCoral", "LightGreen", "LightPink", "LightSalmon", "LightSeaGreen", "LightSkyBlue", "Lime", "Magenta", "MediumAquaMarine", "MediumOrchid", "MediumPurple", "MediumSeaGreen", "MediumSlateBlue", "MediumSpringGreen", "MediumTurquoise", "MediumVioletRed", "Olive", "OliveDrab", "Orange", "OrangeRed", "Orchid", "PaleGoldenRod", "PaleGreen", "PaleTurquoise", "PaleVioletRed", "Pink", "Plum", "PowderBlue", "Red", "RosyBrown", "RoyalBlue", "Salmon", "SandyBrown", "SeaGreen", "Sienna", "SkyBlue", "SlateBlue", "SpringGreen", "Tomato", "Turquoise", "Violet", "Yellow", "YellowGreen"];